import cx from 'classnames';
import { FC, ReactNode } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import { styles } from './SideNavigationWorkspaceItem.styles';

export interface SideNavigationWorkspaceItemProps extends WithStyles<typeof styles> {
  icon: ReactNode;
  active: boolean;
  link: string;
}

const SideNavigationWorkspaceItemComponent: FC<SideNavigationWorkspaceItemProps> = ({
  active,
  classes,
  icon,
  link,
}) => {
  return (
    <a
      className={cx(classes.root, { [classes.rootActive]: active })}
      href={link}
      onClick={(e) => active && e.preventDefault()}
    >
      <span className={classes.icon}>{icon}</span>
    </a>
  );
};

export const SideNavigationWorkspaceItem = withStyles(styles)(SideNavigationWorkspaceItemComponent);
